/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Create_ButtonInputs */



/**
* | output |
* | --- |
* | "Create Issue" |
*
* @param {Manual_Qc_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_create_button = /** @type {((inputs?: Manual_Qc_Create_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Create_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creer l'incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Problem erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea problema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать проблему")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear problema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題を作成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समस्या उत्पन्न करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar problema")
	return /** @type {LocalizedString} */ ("Create Issue")
});